import React from "react";
import {
  GalleryFive,
  GalleryFour,
  GalleryOne,
  GalleryThree,
  Quality10,
  Quality12,
  Quality14,
  Quality15,
  Quality16,
  Quality17,
  Quality18,
  Quality19,
  Quality20,
  Quality21,
  Quality22,
  Quality23,
  Quality24,
  Quality25,
  Quality26,
  Quality27,
  Quality28,
  Quality29,
  Quality30,
  Quality31,
  Quality32,
  Quality33,
  Quality34,
  Quality35,
  Quality36,
  Quality37,
  Quality38,
  Quality39,
  Quality40,
  Quality41,
  Quality42,
  Quality43,
} from "../Images";
import { Link } from "react-router-dom";

const Gallery = () => {
  const galleryImage = [
    GalleryFive,
    GalleryFour,
    // GallerySix,
    GalleryThree,
    GalleryOne,
    Quality10,
    Quality12,
    Quality14,
    Quality15,
    Quality16,
    Quality17,
    Quality18,
    Quality19,
    Quality20,
    Quality21,
    Quality22,
    Quality23,
    Quality24,
    Quality25,
    Quality26,
    Quality27,
    Quality28,
    Quality29,
    Quality30,
    Quality31,
    Quality32,
    Quality33,
    Quality34,
    Quality35,
    Quality36,
    Quality37,
    Quality38,
    Quality39,
    Quality40,
    Quality41,
    Quality42,
    Quality43,
  ];

  return (
    <>
      {galleryImage &&
        galleryImage?.length &&
        galleryImage.map((item, i) => {
          const customClass =
            i == 1 || i == 2 || i == 3 || i == 4
              ? "col-md-6 col-lg-3"
              : "col-md-12 col-lg-6";
          return (
            <>
              <div key={i} className={customClass}>
                {/* <div key={i} className="col-md-12 col-lg-6"> */}
                <Link
                  className="destination-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="destination-img">
                    <img src={item} alt="" />
                  </div>
                </Link>
              </div>
            </>
          );
        })}
    </>
  );
};

export default Gallery;
